import { DateTime } from 'luxon';
// Formats an Apaleo monetary value for display. Apaleo offer amounts are in
// major currency units already (e.g. 200 for $200.00), so no minor-unit
// division is needed. All amounts render with two decimals ($12,345.00).
export const formatMoney = (amount, currency) => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount);
// "2026-09-06" / ISO date-time -> "Sep 6". Used for the free-cancellation
// deadline. Rendered as a zone-agnostic calendar date.
export const formatShortDate = (iso) => {
    if (!iso) {
        return '';
    }
    const parsed = DateTime.fromISO(iso, { zone: 'utc' });
    return parsed.isValid ? parsed.toFormat('MMM d') : '';
};
